
const mernData = [
  {
    id: 1,
    name: "Youtube Channels and Playlists",
    img: "https://w1.pngwing.com/pngs/66/171/png-transparent-google-logo-youtube-youtuber-youtube-rewind-text-area-line.png",
    meaning: `Some Great Channels to follow to learn Web Development`,
    list1: "NetNinja",
    href1:
      "https://www.udemy.com/course/the-complete-nodejs-developer-course-2/",
    list2: "Drew Ryan ",
    href2:
      "https://www.youtube.com/playlist?list=PL-Jc9J83PIiEnK1q9tuVrrORqKBexcE_J",
    list3: "Brad Traversy",
    href3: "https://www.youtube.com/user/TechGuyWeb",
    list4: "Web Dev Simplified ",
    href4: "https://www.youtube.com/channel/UCFbNIlppjAuEX4znoulh0Cw"
  },
  {
    id: 2,
    name: "Some Websites to solve doubts",
    list1: "Stack Overflow",
    href1: "https://stackoverflow.com/",
    list2: "Medium",
    href2: "https://medium.com/",
    list5: " P.S. : The best platform for every answer is Google"
  },
  {
    id: 3,
    name: "The Journey has Just begun",
    meaning:
      "Congratulations on making it this far! Learning Web development is a never ending process new technologies are coming up everyday, but that's what makes it interesting. What we have covered so far will help any new engineer to ACM thapar's Web and App Dev Team to get up to speed with our technologies pretty quickly. There are many more things to be learnt, but building up a solid foundation in the essentials will aid in learning the rest of the technologies."
  }
];

export default mernData;
